import { render, staticRenderFns } from "./imgViewModal.vue?vue&type=template&id=0af080a8"
import script from "./imgViewModal.vue?vue&type=script&lang=ts"
export * from "./imgViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports